module.exports = __webpack_public_path__ + "img/f_25_05.c7b010b2.jpg";